const CACHE_KEY = "cr_fp_cache";

async function sha256Hex(input: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(input);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
}

function buildFingerprintString(): string {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return [
    navigator.userAgent,
    navigator.language,
    `${screen.width}x${screen.height}x${screen.colorDepth}`,
    tz,
    String(navigator.hardwareConcurrency ?? ""),
    navigator.platform,
  ].join("|");
}

export async function getBrowserFingerprint(): Promise<string> {
  const cached = sessionStorage.getItem(CACHE_KEY);
  if (cached) return cached;

  const raw = buildFingerprintString();
  const hex = await sha256Hex(raw);
  try {
    sessionStorage.setItem(CACHE_KEY, hex);
  } catch {
    // sessionStorage quota exceeded or unavailable — proceed without caching
  }
  return hex;
}

export function getOrCreateDeviceId(): string {
  try {
    const existing = localStorage.getItem("cr_device_id");
    if (existing) return existing;
    const id = crypto.randomUUID();
    localStorage.setItem("cr_device_id", id);
    return id;
  } catch {
    // localStorage unavailable (private browsing restrictions, etc.)
    return crypto.randomUUID();
  }
}
